import React from "react";
import Slider from "react-slick";
import Img17 from "../../assets/images/17.png";
import Img18 from "../../assets/images/18.png";
import Img19P from "../../assets/images/19.png";
import Img19J from "../../assets/images/19.jpg";
import Img20 from "../../assets/images/20.jpg";
import Img21 from "../../assets/images/beyond.webp"

const HeaderSlider = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <Arrows />,
    prevArrow: <Arrows />,
    cssEase: "linear",
  };

  function Arrows() {
    return <div style={{display: "none"}} />;
  }

  const images = [
    {
      img: Img21,
    },
    {
      img: Img17,
    },
    {
      img: Img18,
    },
    {
      img: Img19P,
    },
    {
      img: Img19J,
    },
    {
      img: Img20,
    },
  ];

  return (
    <>
      <Slider {...settings}>
        {images?.map((item, index) => {
          return (
            <div key={index}>
              <img
                src={item?.img}
                style={{
                  width: "100%",
                  height: "80vh",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center center",
                }}
              />
            </div>
          );
        })}
      </Slider>
    </>
  );
};

export default HeaderSlider;
